<div class="sync-buttons-container">
  <button mat-raised-button
          color="primary"
          (click)="syncRoutes()"
          [disabled]="syncingRoutes || syncingAll">
    {{ syncingRoutes ? 'Syncing Routes...' : 'Sync Routes' }}
  </button>

  <button mat-raised-button
          color="accent"
          (click)="syncCustomers()"
          [disabled]="syncingCustomers || syncingAll">
    {{ syncingCustomers ? 'Syncing Customers...' : 'Sync Customers' }}
  </button>

  <button mat-raised-button
          color="warn"
          (click)="syncProducts()"
          [disabled]="syncingProducts || syncingAll">
    {{ syncingProducts ? 'Syncing Products...' : 'Sync Products' }}
  </button>

  <button mat-raised-button
          color="primary"
          (click)="syncAll()"
          [disabled]="syncingAll || syncingRoutes || syncingCustomers || syncingProducts">
    {{ syncingAll ? 'Syncing All...' : 'Sync All' }}
  </button>
</div>
